import {
  DELIMITER,
  startInPage,
  TEMP_CONSUMP_KEY,
  liveConnect,
} from '../constants';
import envConfig from './getEnv';
import { getBreadcrumbPath } from './routes';

export const getLiveConnectURL = (siteuuid, contractCode, assetClassCode) =>
  `${
    envConfig.beta ? '/beta' : ''
  }/liveConnect/${siteuuid}/${contractCode}/data-browser?assetClassCode=${assetClassCode}`;

export const getSelectedSite = site => {
  const siteData = site.split(DELIMITER);
  return {
    id: siteData[0],
    siteName: siteData[1] || '',
    org: siteData[2] || '',
    siteCode: siteData[3] || '',
    city: siteData[4] || '',
    state: siteData[5] || '',
    zipCode: siteData[6] || '',
  };
};

export const scrollToTop = () => {
  setTimeout(
    () =>
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      }),
    0,
  );
};

export const getEnvSegment = () => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  if (pathSegments.length === 0 || pathSegments[0] === 'insights') return '';
  return `/${pathSegments[0]}`;
};

export const getBaseURL = () =>
  `${window.location.href.split('/insights/')[0]}/insights`;

export const getStartInOptions = (tcAccess, liveAccess) => {
  const filters = [];
  if (!liveAccess) filters.push(item => item.key !== liveConnect);
  if (!tcAccess) filters.push(item => item.key !== TEMP_CONSUMP_KEY);

  return startInPage.filter(item => filters.every(filter => filter(item)));
};

export const startInObj = {
  todoList: 'todoList',
  siteSummary: 'siteSummary',
  tempConsump: 'tempConsump',
  liveConnect: 'liveConnect',
};

export const defaultStatInfunc = (
  liveAccess,
  tcAccess,
  resolvedDefaultStartIn,
) => {
  const { liveConnect: live, tempConsump, todoList, siteSummary } = startInObj;

  const conditions = {
    [todoList]: todoList,
    [siteSummary]: siteSummary,
    [live]: liveAccess ? live : null,
    [tempConsump]: tcAccess ? tempConsump : null,
  };
  return conditions[resolvedDefaultStartIn] || todoList;
};

export const getStartInLabel = key =>
  startInPage.find(item => item.key === key);

export const getGroupName = (groupArray, groupId) =>
  groupArray?.find(grp => grp?.groupId === groupId);

export const favoriteTransObj = t => ({
  toDoList: t('TODO_LIST'),
  siteSummary: t('SITE_SUMMARY'),
  subscription: t('Subscription'),
  site: t('Site'),
  equipment: t('Equipment_Details'),
  organization: t('Organization'),
  portFolioTrend: t('Portfolio'),
  portFolioTrendReport: t('Equipment_insight_trend_report'),
  siteList: t('Site_list'),
});

/* eslint-disable indent */
export const makeGetURL =
  (
    searchKey,
    searchType,
    siteUUID,
    contractcode,
    resolvedDefaultStartIn,
    bundle,
    groupId,
    savedPath,
  ) =>
  label =>
    getBreadcrumbPath({
      label,
      searchKey,
      searchType,
      siteUUID,
      contractcode,
      resolvedDefaultStartIn,
      bundle,
      groupId,
      savedPath,
    });
/* eslint-enable indent */
